import { Request, Response } from 'kts-scaffold-framework/server';
import { CallType } from 'kts-scaffold-framework/utils/ajax';
import { Urls } from 'kts-platform-frame/entry/constant';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import ApiBasic from 'kts-platform-frame/api/ApiBasic';
import IData from './IData';
import IOptions from './IOptions';

/**
 * 查询菜单可以显示的APP
 */
class QueryMenuApp extends ApiBasic<IOptions, IData> {

    /** 入口 */
    public async api(option: IOptions): Promise<Response<IData>> {
        const req: Request = new Request(CallType.GET, Urls.queryMenuApp, option);
        let data: Response<any> = await this.callAjax(req);
        if(!data.er){
            MyStore.instance.dispatch(reducers.system.ActionTypes.updateMenuAppList, data.res);
        }
        return new Response<IData>(data.er, { list: data.res });
    }
}

export default new QueryMenuApp().run;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/appStore/queryMenuApp/index.ts